InlineVariations = window.InlineVariations ?= {}
InlineVariations.Views ?= {}

InlineVariations.Views.Trait = Backbone.View.extend
  dropdownSelection: '.inline-variation-dropdown-selection'
  traitValues: '.inline-variation-trait-value'
  inlineTitleHtml: '.inline-variation-trait-title'
  body: 'body'

  touch:
    main: '.t-main'

  events:
    'click .inline-variation-dropdown-selection': 'toggleDropdown'
    'click .inline-variation-trait-value': 'traitValueSelection'

  webSwatchEvents:
    'mouseenter .inline-variation-trait-value': 'updateTitleToHoveredTrait'
    'mouseleave .inline-variation-trait-value': 'updateTitleToOriginalTrait'

  initialize: ->
    @layout = @model.get 'layout'
    @title = @model.get 'title'
    @isSwatchImageDropdown = @layout.isImageSwatch and @layout.isGenericDropdown
    @isTouch = @options.isTouch

    @$body = $(@body)
    @$traitValues = @$el.find @traitValues

    if @layout.isGenericDropdown
      @placeholderHtml = @model.get 'title'
      @placeholderValue = @model.get 'placeholderValue'
      @placeholderValueId = @model.get 'placeholderValueId'
      @$titleHtml = @$el.find @dropdownSelection
    else
      @$titleHtml = @$el.find @inlineTitleHtml

    @$body = $(@touch.main) if @layout.enableFilterSheet

    @listenTo @model, 'change:selectedTraitValue', @setTraitValue

    _.extend @events, @webSwatchEvents unless @isTouch or not @layout.isSwatch

    @processTraitValues()

  processTraitValues: ->
    for value in @model.get 'values'
      value.$el = @$el.find "##{value.id}"

  toggleDropdown: (e) ->
    isOpen = @$el.hasClass 'open'
    @model.collection.closeDropdowns()

    unless isOpen
      @model.collection.view.showBackdrop()
      @$el.addClass('open')
      @sendDropdownTrackingEvent isOpen

  sendDropdownTrackingEvent: (isOpen) ->
    status = if isOpen then 'close' else 'open'
    OptimizeSuite.TrackingHub.add "inline-variations-dropdown-#{status}"

  closeDropdown: ->
    @$body.addClass 'stop-propagation' if @layout.enableFilterSheet
    return unless isOpen = @$el.hasClass 'open'

    @sendDropdownTrackingEvent isOpen
    @$el.removeClass 'open'

  traitValueSelection: (e) ->
    $target = $(e.currentTarget)
    return e.stopPropagation() if $target.hasClass 'sold-out'

    @$body.addClass 'stop-propagation' if @layout.enableFilterSheet
    selected = $target.hasClass 'selected'
    return if selected and @layout.isGenericDropdown and not @layout.isSwatch

    @$traitValues.removeClass 'selected'

    if selected
      @model.setSelectedTraitValueById()
    else
      @model.setSelectedTraitValueById $target.attr('id')

    @model.collection.view.render()

  updateTitleToHoveredTrait: (e) ->
    $target = $(e.currentTarget)
    return if $target.hasClass 'sold-out'

    if currentTraitValue = @model.getTraitValueById $target.attr('id')
      @$titleHtml.html currentTraitValue.html

  updateTitleToOriginalTrait: (e) ->
    return if $(e.currentTarget).hasClass 'sold-out'

    @$titleHtml.html @model.get('selectedTraitValueHtml') or @title

  setTraitValue: ->
    @closeDropdown() unless @layout.enableFilterSheet
    selectedTraitValue = @model.get('selectedTraitValueHtml')
    selectedTraitValueId = @model.get('selectedTraitValueId')

    if @layout.isGenericDropdown or @layout.isSwatch
      unless selectedTraitValue
        if @layout.isSwatch
          selectedTraitValue = @title
        else
          selectedTraitValue = @placeholderHtml
          selectedTraitValueId = @placeholderValueId

      @$titleHtml.html selectedTraitValue

    @$traitValues.each ->
      $traitValue = $(this)
      $traitValue.toggleClass 'selected', $traitValue.attr('id') is selectedTraitValueId

module.exports = InlineVariations.Views.Trait
